import { SerializedData, Store } from "bernie-core";
import { PoiStore } from "./PoiStore";
import { TCSService } from "src/services/TCSService";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { action, observable } from "mobx";
import { PoiForMap } from "src/components/flexComponents/Maps/typings";
import * as generated from "tcs-graphql/__generated__/types";
import { POI_FETCH_ERROR } from "src/config/systemEvents";

export class ClientPoiStore extends Store implements PoiStore {
  private TCSService: TCSService;

  @observable
  private poisForRegion: PoiForMap[] = [];

  public constructor(state: SerializedData = {}, tcsService: TCSService, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.TCSService = tcsService;
  }

  @action
  public fetchPoisForRegion = async (regionId: string, locale: string, limit = 10) => {
    try {
      const response = await this.TCSService.fetchPoisForRegionIdAndLocale(regionId, locale, limit);
      if (this.isValidTcsResponse(response)) {
        this.poisForRegion = response
          .destination![0]!.poi!.filter((poi) => this.isValidTcsPoi(poi))
          .map((validPoi) => this.createPoiForMap(validPoi));
      }
    } catch (err) {
      this.logger.logEvent(POI_FETCH_ERROR, err);
    }
  };

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public getPois: () => PoiForMap[] = () => this.poisForRegion;

  private isValidTcsResponse(response: generated.TopPoiQuery) {
    return (
      response.destination &&
      response.destination.length > 0 &&
      response.destination[0] &&
      response.destination[0]!.poi &&
      response.destination[0]!.poi.length > 0
    );
  }

  private isValidTcsPoi(poi: generated.DestinationEntity | null) {
    return (
      poi &&
      poi.id &&
      poi.content &&
      poi.content.geo &&
      poi.content.geo.name &&
      poi.content.geo.name.localized &&
      poi.content.geo.latitude &&
      poi.content.geo.longitude
    );
  }

  private getPoiImage(poi: generated.DestinationEntity | null) {
    return (
      (poi &&
        poi.content &&
        poi.content.asset &&
        poi.content.asset.image &&
        poi.content.asset.image.info &&
        poi.content.asset.image.info.length > 0 &&
        poi.content.asset.image.info[0] &&
        poi.content.asset.image.info[0]!.url) ||
      ""
    );
  }

  private getPoiDescription(poi: generated.DestinationEntity | null) {
    return (
      (poi &&
        poi.content &&
        poi.content.asset &&
        poi.content.asset.text &&
        poi.content.asset.text.info &&
        poi.content.asset.text.info.length > 0 &&
        poi.content.asset.text.info[0] &&
        poi.content.asset.text.info[0]!.text) ||
      ""
    );
  }

  private createPoiForMap(poi: generated.DestinationEntity | null): PoiForMap {
    const name = poi!.content!.geo!.name!.localized!;
    const latitude = poi!.content!.geo!.latitude!;
    const longitude = poi!.content!.geo!.longitude!;
    const id = poi!.id!;

    return {
      id,
      name,
      latitude,
      longitude,
      description: this.getPoiDescription(poi),
      imageUrl: this.getPoiImage(poi),
      icon: {
        type: "place",
      },
    };
  }
}
